import { useAuth } from '@auth/useAuth'
import AnonPaths from '@globals/paths/anon'
import { logout } from '@kudos/http-client'
import Typography from '@mui/material/Typography'
import { T } from '@transifex/react'
import { useEffect, useRef } from 'react'
import { Navigate, useSearchParams } from 'react-router'

export const LogOutRoute = () => {
  const { clearAuth, isAuthenticated } = useAuth()
  const [searchParams] = useSearchParams()
  const userEmail = searchParams.get('userEmail')
  const redirectPath = !!userEmail
    ? `${AnonPaths.userLogin()}?userEmail=${encodeURIComponent(userEmail)}`
    : AnonPaths.userLogin()

  if (!isAuthenticated) return <Navigate to={redirectPath} />

  return <AutoLogOut onLoggedOut={clearAuth} />
}

const AutoLogOut = ({ onLoggedOut }: { onLoggedOut: () => void }) => {
  const hasLoggedOut = useRef<boolean>(false)
  useEffect(() => {
    if (!hasLoggedOut.current) {
      logout()
        .catch(() => {
          // Token may have already expired. Continue regardless so
          // that clear the local auth state and can recover.
        })
        .finally(onLoggedOut)
    }
    hasLoggedOut.current = true
  }, [onLoggedOut])

  return (
    <Typography>
      <T _str="Logging out..." />
    </Typography>
  )
}

// eslint-disable-next-line local/require-with-app-permission-for-routes
export default LogOutRoute
